import { ResponsiveContainer, ComposedChart, Area, Line, XAxis, ReferenceLine } from "recharts";

const data = Array.from({ length: 16 }, (_, i) => {
  const base = 420 - i * 26 + Math.sin(i) * 8;
  return { m: i, cash: i <= 6 ? base : undefined, forecast: i >= 6 ? base : undefined, scenario: i >= 6 ? 420 - 6 * 26 + Math.sin(6) * 8 - (i - 6) * 11 : undefined };
});

export const HeroChart = () => (
  <div data-testid="hero-chart" className="rounded-2xl border border-[#2A2A2A] bg-[#121212]/90 backdrop-blur-xl p-6">
    <div className="flex items-start justify-between">
      <div>
        <p className="font-mono text-[11px] text-[#A3A3A3]">CASH BALANCE</p>
        <p className="font-mono text-3xl font-bold mt-1">$412,850</p>
      </div>
      <div className="text-right">
        <p className="font-mono text-[11px] text-[#9D00FF]">ZERO CASH DATE</p>
        <p className="font-mono text-lg mt-1">Mar 14, 2027</p>
      </div>
    </div>
    <div className="h-56 mt-4">
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={data} margin={{ top: 8, right: 0, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="hg" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#00FF9D" stopOpacity={0.35} />
              <stop offset="100%" stopColor="#00FF9D" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="m" hide />
          <ReferenceLine y={0} stroke="#2A2A2A" />
          <Area dataKey="cash" stroke="#00FF9D" strokeWidth={2.5} fill="url(#hg)" animationDuration={1600} />
          <Line dataKey="forecast" stroke="#00FF9D" strokeOpacity={0.5} strokeDasharray="5 5" dot={false} strokeWidth={2} animationDuration={1600} />
          <Line dataKey="scenario" stroke="#9D00FF" strokeDasharray="6 4" dot={false} strokeWidth={2.5} animationDuration={2200} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
    <div className="mt-4 rounded-lg border border-[#9D00FF]/40 bg-[#9D00FF]/10 px-4 py-3 font-mono text-xs text-[#E0B3FF]">
      AI: Cutting Google Ads ($8k/mo) pushes your Zero Cash Date out by 4.1 months.
    </div>
  </div>
);
